import { SiteCoreDictionary } from './types';

const fallbackDictionary: SiteCoreDictionary = {
    transactionTo: 'Til',
    transactionFrom: 'Fra',
    transactionDateLabel: 'Dato',
    transactionBooked: 'Bokført',
    transactionsReserved: 'Reservert',
    transactionMessage: 'Beskjed',
    downloadAsPdfText: 'Last ned som PDF',
};

export default fallbackDictionary;
